import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CURRENT_USER_DETAILS } from "@Client/@Modules/main/store/account/account-getters";
import { mapGetters, mapState } from "vuex";
import ApplicationStatusProgressBar from "./application-status-progress-bar.vue";
import ClientsActivity from "./clients-activity.vue";
import OutstandingDocuments from "./outstanding-documents.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DashboardContainer",
  title() {
    return this.$t("sidebar.sections.dashboard");
  },
  components: {
    ApplicationStatusProgressBar,
    ClientsActivity,
    OutstandingDocuments
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_DETAILS])), mapState("DeprecatedApplicationStore", ["applications"])), mapState("AccountStore", ["selectedApplicationId"])), {}, {
    clientName() {
      return this.CURRENT_USER_DETAILS.givenName;
    },
    currentApplicationStatus() {
      var _this$applications$by, _this$applications$by2;
      return (_this$applications$by = (_this$applications$by2 = this.applications.byId[this.selectedApplicationId]) == null ? void 0 : _this$applications$by2.applicationStatus) != null ? _this$applications$by : "pending";
    }
  }),
  beforeMount() {
    Amplitude.logEvent("Dashboard - visited");
  }
});